var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { createRoot } from "react-dom/client";
import isEqual from "react-fast-compare";
import { addCheckClickOutside, applyStyleOrClass, checkKey, concatClassNames, createElementWithClass, editComponentUnmount, trackOnElement } from "../../utils/Functions";
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dropdownContainer = createElementWithClass("div", "dropdown-container");
        _this.componentDidMount = function () {
            applyStyleOrClass(_this.dropdownContainer, _this.props.style, _this.props.className);
            editComponentUnmount(_this.checkPosition, _this, "resize");
        };
        _this.componentDidUpdate = function (prevProps) {
            if (!isEqual(prevProps.options.map(_this.clearOption), _this.props.options.map(_this.clearOption)) && document.body.contains(_this.dropdownContainer))
                _this.show();
        };
        _this.clearOption = function (o) { return (__assign(__assign({}, o), { onClick: null })); };
        _this.componentWillUnmount = function () {
            _this.hide();
            setTimeout(function () { var _a; return (_a = _this.root) === null || _a === void 0 ? void 0 : _a.unmount(); });
        };
        _this.hide = function () { return _this.dropdownContainer.remove(); };
        _this.show = function () {
            var closeAfterSelect = _this.props.closeAfterSelect;
            if (!_this.root)
                _this.root = createRoot(_this.dropdownContainer);
            _this.root.render(_this.props.options.map(function (o, i) {
                var disabled = o.disabled, onClick = o.onClick, className = o.className, style = o.style;
                var div;
                return React.createElement("div", { className: concatClassNames([disabled ? "disabled" : "", "dolfo-dropdown-option"], className), key: i, onClick: function (e) {
                        if (!disabled && onClick) {
                            onClick(e);
                            if (closeAfterSelect)
                                _this.hide();
                        }
                    }, style: style, ref: function (r) { return div = r; }, tabIndex: !disabled ? 0 : null, onKeyUp: function (e) { return checkKey(e, function () { return div.click(); }, disabled); } }, o.children);
            }));
            document.body.appendChild(_this.dropdownContainer);
            _this.checkPosition();
            setTimeout(function () { return window.dispatchEvent(new Event("resize")); });
        };
        _this.checkPosition = function () {
            var _a = _this.dropdownContainer, offsetLeft = _a.offsetLeft, offsetWidth = _a.offsetWidth;
            if (offsetLeft + offsetWidth > document.body.clientWidth) {
                _this.dropdownContainer.classList.add("auto");
                _this.dropdownContainer.style.right = "10px";
            }
            else if (_this.dropdownContainer.classList.contains("auto")) {
                _this.dropdownContainer.classList.remove("auto");
                _this.checkPosition();
            }
        };
        _this.render = function () {
            var _a = _this.props, children = _a.children, activateOnRightClick = _a.activateOnRightClick, fn = function (e) {
                if (!_this.node) {
                    _this.node = e.target;
                    addCheckClickOutside(_this.hide, _this, _this.dropdownContainer);
                    trackOnElement(_this.dropdownContainer, _this, false, false);
                }
                _this.show();
            };
            return React.Children.map(children, function (c) {
                return React.cloneElement(c, {
                    onContextMenu: function (e) {
                        if (!activateOnRightClick)
                            return;
                        e.preventDefault();
                        fn(e);
                    },
                    onClick: function (e) {
                        if (c.props.onClick)
                            c.props.onClick(e);
                        if (activateOnRightClick)
                            return;
                        fn(e);
                    }
                });
            });
        };
        return _this;
    }
    return Dropdown;
}(React.Component));
export { Dropdown };
